import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CompanyRegistrationHeader from '../components/Service/Consultation/CompanyRegistrationHeader';
import CompanyRegistrationInfo from '../components/Service/HrRecruitment/CompanyRegistrationInfo';
import ConditionsForRegister from '../components/Service/HrRecruitment/ConditionsForRegister';
import RegistrationProcess from '../components/Service/HrRecruitment/RegistrationProcess';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';
import OnlineConsultation from '../components/Service/ConsultationForm/OnlineConsultation';
import { useParams } from 'react-router-dom';

export default function ConsultationOnlineConsultation() {
    const {courseId} = useParams();
    const [activity, setActivity] = useState({});
    return (
        <>
            <Header />
            <CompanyRegistrationHeader activity={activity} />
            <OnlineConsultation 
            activity={activity} 
            setActivity={setActivity} 
            />
            {/* <CompanyRegistrationInfo /> */}
            {/* <ConditionsForRegister /> */}
            {/* <RegistrationProcess /> */}
            
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}
